// Products-specific table state mappings
import { getSingleValue, getArrayValue } from '@/lib/utils/table-state-utils';

export const productsFilterMapping = {
    name: (value: any) => {
        return { name: getSingleValue(value) };
    },
};

export const productsQueryParamsMapping = {
    name: (value: URLSearchParams) => {
        return value.get('name')
    },
};

// Sort field mappings for products (frontend column ID -> backend sort field)
export const productsSortMapping = {
    id: 'created_at' as const,
    name: 'name' as const,
    price: 'price' as const,
    description: 'description' as const,
    createdAt: 'created_at' as const,
} as const;

